"use client";

import { useEffect } from "react";
import startOverfadeAuto from "@/utils/overfade";

export { getPostHogInitConfig } from "@/lib/posthog-config";

export function OverfadeProvider() {
  useEffect(() => {
    const stop = startOverfadeAuto({
      baseFade: 24,
    });
    return stop;
  }, []);
  return null;
}
